<template>
  <Modal v-model="visibility" footer-hide :width="380" @on-cancel="onCancel">
    <div class="modal-header" slot="header">安全验证</div>
    <div class="content">
      <div id="captcha-box"></div>
    </div>
  </Modal>
</template>
<script>
/* global TAC */
import { API_BASE_URL } from '@/utils/config'

export default {
  name: "Captcha",
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      visibility: false,
      globalTAC: null,
      config: null,
      style: {},
      type: 'CONCAT'
    }
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    onShow() {
      this.visibility = true;
      this.openCaptcha()
    },
    onCancel() {
      this.visibility = false;
    },
    getConfig() {
      if (!this.config) {
        this.config = {
          // 生成接口
          requestCaptchaDataUrl: `${API_BASE_URL}/gsweb/sys/captcha/gen?type=${this.type}`,
          // 验证接口
          validCaptchaUrl: `${API_BASE_URL}/gsweb/sys/captcha/check`,
          // 验证码绑定的div块
          bindEl: "#captcha-box",
          // 验证成功回调函数
          validSuccess: (res, c, tac) => {
            // 销毁验证码服务
            tac.destroyWindow();
            this.onCancel()
            this.$emit('custom-event', res.data)
          }
        }
      }
    },
    openCaptcha() {
      if (this.globalTAC) {
        this.globalTAC.destroyWindow();
      }
      this.globalTAC = new TAC(this.config, this.style).init();
    },
  },

};
</script>
<style lang="less" scoped>

</style>
